import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  analyticsLicensesCount: {
    defaultMessage: '{count, plural, one {# analytics license} other {# analytics licenses}}',
    description: 'Number of analytics licenses for a subscription plan',
    id: 'f2buup',
  },
  selectAnalyticsLicensesLabel: {
    defaultMessage: 'Select analytics licenses',
    description: 'Label for analytics licenses input',
    id: 'V77qc9',
  },
  analyticsLicenseAdditionalCost: {
    defaultMessage: '+ {cost}',
    description: 'Additional cost for the selected analytics license count',
    id: 'g1TpbT',
  },
  includedAbbreviation: {
    defaultMessage: 'Incl.',
    description: 'Abbreviation for included',
    id: 'm4kUIL',
  },
});
